import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, switchMap } from 'rxjs/operators';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { CustomerGroupInfoModel, CustomerGroupService } from '@railmybox/api-user';

@UntilDestroy()
@Component({
  selector: 'rmb-customer-group-select',
  templateUrl: './customer-group-select.component.html',
  styleUrls: ['./customer-group-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(CustomerGroupSelectComponent)],
  standalone: false,
})
export class CustomerGroupSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private readonly customerGroupService = inject(CustomerGroupService);

  customerGroups$: Observable<CustomerGroupInfoModel[]>;
  searchControl: FormControl = new FormControl(undefined);
  selectedName: string;
  @Input() clearable = true;

  ngOnInit(): void {
    this.customerGroups$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.customerGroupService.adminListCustomerGroups({ query }) : of([]))),
      map((x) => x.filter((item) => item.active === true))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(model: CustomerGroupInfoModel): void {
    this.selectedName = model?.name;
    this.value = model?.id;
    this.onChange(model?.id);
    this.changed.emit(model?.id);
  }

  async writeValue(value: string): Promise<void> {
    super.writeValue(value);

    if (!value) {
      this.selectedName = null;
      return;
    }

    const model = await this.customerGroupService
      .adminListCustomerGroups()
      .toPromise()
      .then((filteredValues) => filteredValues.find((model) => model.id === value));

    // In case no entry found with that id
    if (!model) {
      return;
    }

    this.value = model.id;
    this.selectedName = model.name;
  }
}
